import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../../../context/AppContext";
import { setJourneyIntent } from "../../../../utils/journeyIntent";
import JourneyPage from "./components/JourneyPage";

export default function Welcome() {
    const navigate = useNavigate();
    const { appData, setPageTitle } = useAppContext();

    useEffect(() => {
        setPageTitle("Welcome");
    }, [setPageTitle]);

    const chooseJourney = (intent) => {
        setJourneyIntent({ appId: appData?.id, intent });
        navigate(intent === "mentor" ? "/welcome/mentor" : "/welcome/student", { replace: true });
    };

    return (
        <JourneyPage
            eyebrow="Choose your journey"
            title={`What brings you to ${appData?.name || "Robotrader"}?`}
            subtitle="Pick the path that matches what you want to do first. You can switch this later from the welcome pages."
        >
            <div className="row g-3">
                <div className="col-md-6">
                    <button
                        type="button"
                        className="journey-choice-card card custom-card h-100 text-start w-100"
                        onClick={() => chooseJourney("mentor")}
                    >
                        <div className="card-body p-4 p-lg-5">
                            <div className="journey-icon journey-icon-primary mb-4">
                                <i className="fas fa-robot"></i>
                            </div>
                            <h3 className="journey-card-title h4">I am a Mentor</h3>
                            <p className="journey-card-copy mb-4">I want to activate my portal, create or manage EAs, issue licences, and support my students.</p>
                            <span className="btn btn-primary">Start Mentor Setup</span>
                        </div>
                    </button>
                </div>
                <div className="col-md-6">
                    <button
                        type="button"
                        className="journey-choice-card card custom-card h-100 text-start w-100"
                        onClick={() => chooseJourney("student")}
                    >
                        <div className="card-body p-4 p-lg-5">
                            <div className="journey-icon journey-icon-success mb-4">
                                <i className="fas fa-mobile-alt"></i>
                            </div>
                            <h3 className="journey-card-title h4">I am a Student</h3>
                            <p className="journey-card-copy mb-4">I want the mobile app, AI trading tools, account activation, tokens, and help getting started.</p>
                            <span className="btn btn-success">Open Student Guide</span>
                        </div>
                    </button>
                </div>
            </div>
        </JourneyPage>
    );
}
